import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-querenyuanzhengqueduigoutijiaochenggongwancheng",
  "use": "icon-querenyuanzhengqueduigoutijiaochenggongwancheng-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-querenyuanzhengqueduigoutijiaochenggongwancheng\"><path d=\"M512 967.111111c251.363556 0 455.111111-203.747556 455.111111-455.111111S763.363556 56.888889 512 56.888889 56.888889 260.636444 56.888889 512s203.747556 455.111111 455.111111 455.111111z m239.815111-627.484444a42.666667 42.666667 0 0 1 60.387556 60.302222l-340.906667 341.333333a42.666667 42.666667 0 0 1-57.969778 2.247111l-199.111111-170.666666a42.666667 42.666667 0 0 1 55.552-64.796445l169.073778 144.952889L751.815111 339.626667z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/querenyuanzhengqueduigoutijiaochenggongwancheng.svg
// module id = bb/d
// module chunks = 12